exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.delete {\n    color: red;\n}\n.card {\n    height: 100%\n}\nh4 {\n    display: inline-block; /* to make it inline */\n}\n.no-border {\n    border: 0;\n}\n#loading {\n    background: rgba(255, 255, 255, 0.6);\n    position: fixed;\n    height: 100vh;\n    width: 100vw;\n    z-index: 10010;\n    top: 0;\n    left: 0;\n    text-align: center;\n}\n#loading i {\n    Position: absolute;\n    Top: 50%;\n    Transform: translateY(-50%);\n}\n.no-border {\n    border: 0;\n}\n.hover:hover {\n    color: blue;\n}\n", ""]);

// exports
